import Scraper from '~publish/legacy/composer/composer/utils/Scraper'
import { useSplitEnabled } from '@buffer-mono/features'
import { useEffect } from 'react'

const IsRespectfulScraperEnabledFlag = 'is-respectful-scraper-enabled' as const

/**
 * Sync the scraper config between legacy and new app
 *
 * @returns JSX.Element
 */
export const SyncScraperConfig = (): JSX.Element => {
  const isRespectfulScraperEnabled = useSplitEnabled(
    IsRespectfulScraperEnabledFlag,
  )

  useEffect(() => {
    if (isRespectfulScraperEnabled.isReady) {
      Scraper.configure({
        isRespectfulScraperEnabled: isRespectfulScraperEnabled.isEnabled,
      })
    }
  }, [isRespectfulScraperEnabled])

  return <></>
}
